import { Box, Container, Link, Stack } from "@mui/material";
import React from "react";
import logo from "../../images/logos.png";

export default function Footer() {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          color: "white",
          py: 2
        }}
      >
        <Box sx={{ maxWidth: 280, margin: "auto" }}>
          <img src={logo} width="100%" alt="" />
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          backgroundColor: "black",
          color: "white",
          py: 2,
          "& a": {
            color: "white",
            textDecoration: "none"
          }
        }}
      >
        <Container maxWidth="lg">
          <Stack
            direction={{ xs: "column-reverse", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={{ xs: 2, sm: "auto" }}
          >
            <p style={{ margin: 0 }}>Copyright © 2022 KeywordsFly</p>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <Link>Terms of use</Link>
              <Link>Privacy policy</Link>
            </Stack>
          </Stack>
        </Container>
      </Box>
    </>
  );
}
